export enum OptionsModalSource {
    DATALIST_ITEM = 'DATALIST_ITEM',
    MOBILE_VIEWER = 'MOBILE_VIEWER',
    PUBLIC_FILE = 'PUBLIC_FILE',
    TOOLBAR = 'TOOLBAR',
}
